import RemoveGridItem from './remove-grid-item';

export default RemoveGridItem;